import { http } from "../api/http";
import Utils from "../utils";

export const runbookVersionService = {
  get,
  create,
  update,
  deleteVersion,
};

async function get(requestParameters) {
  let url = `/runbook-version?${Utils.objectToQueryString(requestParameters)}`;

  const response = await http.get(url);
  return response;
}

async function create(requestBody) {
  let url = `/runbook-version/create`;

  const response = await http.post(url, JSON.stringify(requestBody));
  return response;
}

async function update(requestBody) {
  let url = `/runbook-version/update`;

  const response = await http.patch(url, JSON.stringify(requestBody));
  return response;
}

async function deleteVersion(requestParameters) {
  let url = `/runbook-version/delete?${Utils.objectToQueryString(requestParameters)}`;

  const response = await http.delete(url);
  return response;
}
